import { IStores } from "./index";
import * as services from "services";
import { ListStoreConstructor } from "./ListStoreConstructor";
import { CONTRACT_STATUS_ENUM } from "interfaces";

export class PendingActionsContractList extends ListStoreConstructor<any> {
  private getDefaultStatuses() {
    const { isOperator, isCustomer } = this.stores.user.roles;

    if (isOperator) {
      return [CONTRACT_STATUS_ENUM.DRAFT, CONTRACT_STATUS_ENUM.BLOCKED];
    }

    if (isCustomer) {
      return [CONTRACT_STATUS_ENUM.DRAFT_DECLINED];
    }

    return undefined;
  }

  constructor(stores: IStores) {
    super(
      stores,
      (params) => {
        const statuses = params?.statuses ?? this.getDefaultStatuses();
        const nextParams = statuses ? { ...params, statuses } : params;

        return services.getContractList(nextParams).then((response) => ({
          content: response.content || [],
          size: response.size || 0,
          totalPages: response.totalPages || 0,
          totalElements: response.totalElements || 0,
        }));
      },
      {
        sorters: {
          statusDate: "asc",
        },
        pollingInterval: 10000,
      }
    );
  }

  removeFilters() {
    const clearedFilters = Object.entries(this.filters).reduce((acc: any, [name]) => {
      acc[name] = undefined;
      return acc;
    }, {});

    const defaultStatuses = this.getDefaultStatuses();

    this.onChangeDataFlow({
      filters: {
        ...clearedFilters,
        statuses: defaultStatuses,
      },
      sorters: this.defaultSorters,
    });
  }
}
